var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { useCheckForUpdates } from '../hooks/useCheckForUpdates';
import { useStatusBarStyle } from '../hooks/useStatusBarStyle';
import { StatusBarStyle } from '@capacitor/core';
import { useSafeArea } from '../hooks/useSafeArea';
var backgroundImage = require('../../images/background.png');
export var AppBackground = function (props) {
    useCheckForUpdates();
    useStatusBarStyle(StatusBarStyle.Dark);
    var topMargin = useSafeArea();
    return (jsx("div", __assign({ sx: {
            bg: 'dark',
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            position: 'fixed',
            overflow: 'hidden',
            backgroundImage: "url('".concat(backgroundImage, "')"),
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            paddingTop: topMargin !== null && topMargin !== void 0 ? topMargin : 'env(safe-area-inset-top)',
            paddingLeft: 'env(safe-area-inset-left)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
        } }, props)));
};
//# sourceMappingURL=AppBackground.js.map